import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuth0 } from '@auth0/auth0-react';
import { Tabs, Text } from '@chakra-ui/react';
import { ListingGrid } from '@client/components/collections/ListingGrid';
import { ShopGrid } from '@client/components/collections/ShopGrid';
import { AppError } from '@client/components/feedback/AppError';
import { CLIENT_ROUTES } from '@client/constants';
import { useApiClient } from '@client/hooks/useApiClient';
import { useMinDuration } from '@client/hooks/useMinDuration';
import { sidebarGridCols } from '@client/theme';
import { callApi } from '@client/utils/apiUtils';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
export const FavoritesPage = () => {
    const { isAuthenticated, loginWithRedirect, isLoading: authIsLoading, } = useAuth0();
    const apiClient = useApiClient();
    const navigate = useNavigate();
    const { tab } = useParams();
    const activeTab = tab === CLIENT_ROUTES.shops
        ? CLIENT_ROUTES.shops
        : CLIENT_ROUTES.listings;
    const [listings, setListings] = useState([]);
    const [listingShops, setListingShops] = useState([]);
    const [shops, setShops] = useState([]);
    const [dataLoading, setDataLoading] = useState(true);
    const [error, setError] = useState(null);
    const isLoading = useMinDuration(dataLoading);
    const loadFavorites = async () => {
        setDataLoading(true);
        setError(null);
        const [listingsResult, shopsResult] = await Promise.all([
            callApi(apiClient.me.getFavorites()),
            callApi(apiClient.me.getFavoriteShops()),
        ]);
        if (listingsResult.error !== null ||
            shopsResult.error !== null) {
            setError('Failed to load favorites');
        }
        else {
            setListings(listingsResult.data.listings);
            setListingShops(listingsResult.data.shops);
            setShops(shopsResult.data);
        }
        setDataLoading(false);
    };
    useEffect(() => {
        if (!authIsLoading && !isAuthenticated) {
            loginWithRedirect({
                appState: { returnTo: `/${CLIENT_ROUTES.favorites}` },
            });
            return;
        }
        loadFavorites();
    }, [authIsLoading]);
    if (error) {
        return _jsx(AppError, { title: error });
    }
    const gridColumns = sidebarGridCols;
    return (_jsxs(Tabs.Root, { value: activeTab, onValueChange: ({ value }) => navigate(`/${CLIENT_ROUTES.favorites}/${value}`), variant: "subtle", size: "lg", children: [_jsxs(Tabs.List, { children: [_jsx(Tabs.Trigger, { value: CLIENT_ROUTES.listings, fontSize: 20, children: "Listings" }), _jsx(Tabs.Trigger, { value: CLIENT_ROUTES.shops, fontSize: 20, children: "Shops" })] }), _jsx(Tabs.Content, { value: CLIENT_ROUTES.shops, children: !isLoading && shops.length === 0 ? (_jsx(Text, { fontSize: 20, children: "You haven't favorited any shops yet." })) : (_jsx(ShopGrid, { shops: shops, isLoading: isLoading, columns: gridColumns })) }), _jsx(Tabs.Content, { value: CLIENT_ROUTES.listings, children: !isLoading && listings.length === 0 ? (_jsx(Text, { fontSize: 20, children: "You haven't favorited any listings yet." })) : (_jsx(ListingGrid, { listings: listings, isLoading: isLoading, columns: gridColumns, shops: listingShops })) })] }));
};
